import type { Customer } from '@/types/customer';

export const mockCustomers: Customer[] = [
  { id: 'CUST-ACME',  name: 'Acme S.L.',                    shortName: 'Acme',      country: 'ES', segment: 'energy',     logoSeed: 'acme' },
  { id: 'CUST-SOLT',  name: 'Solartech Iberia',             shortName: 'Solartech', country: 'ES', segment: 'energy',     logoSeed: 'solar' },
  { id: 'CUST-OTIS',  name: 'Otis Elevator Co.',            shortName: 'Otis',      country: 'US', segment: 'elevators',  logoSeed: 'otis' },
  { id: 'CUST-SCHN',  name: 'Schindler Group',              shortName: 'Schindler', country: 'CH', segment: 'elevators',  logoSeed: 'schn' },
  { id: 'CUST-ULLW',  name: 'Ullswater Investments S.L.',   shortName: 'Ullswater', country: 'ES', segment: 'industrial', logoSeed: 'ullw' },
  { id: 'CUST-AIRB',  name: 'Airbus Components',            shortName: 'Airbus',    country: 'FR', segment: 'aerospace',  logoSeed: 'airb' },
];

export function getCustomer(id: string): Customer | undefined {
  return mockCustomers.find((c) => c.id === id);
}

export function findCustomerByName(query: string): Customer | undefined {
  const q = query.toLowerCase().trim();
  return mockCustomers.find(
    (c) =>
      c.shortName.toLowerCase() === q ||
      c.name.toLowerCase().includes(q) ||
      c.shortName.toLowerCase().includes(q),
  );
}
